import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Mail, MapPin, Phone, Send } from 'lucide-react';
import { toast } from 'sonner';
import { SEO } from '@/components/SEO';

export default function ContactPage() {
  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Message sent! We will get back to you soon.');
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 animate-fade-in" data-testid="contact-page">
      <SEO
        title="Contact Us"
        description="Get in touch with the DoggoHub team. We're here to help with any questions about our dog marketplace, listings, or services."
        keywords="contact DoggoHub, dog marketplace support, help, customer service"
      />
      <h1 className="font-['Nunito'] font-extrabold text-3xl sm:text-4xl text-[#1A1D20] tracking-tight mb-2">
        Contact Us
      </h1>
      <p className="text-[#5C636A] mb-8">Have questions? We'd love to hear from you.</p>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 bg-white rounded-3xl p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <Label className="text-xs font-medium text-[#5C636A]">Name</Label>
                <Input className="mt-1 rounded-xl bg-gray-50" placeholder="Your name" required data-testid="contact-name-input" />
              </div>
              <div>
                <Label className="text-xs font-medium text-[#5C636A]">Email</Label>
                <Input type="email" className="mt-1 rounded-xl bg-gray-50" placeholder="you@example.com" required data-testid="contact-email-input" />
              </div>
            </div>
            <div>
              <Label className="text-xs font-medium text-[#5C636A]">Subject</Label>
              <Input className="mt-1 rounded-xl bg-gray-50" placeholder="How can we help?" required data-testid="contact-subject-input" />
            </div>
            <div>
              <Label className="text-xs font-medium text-[#5C636A]">Message</Label>
              <Textarea className="mt-1 rounded-xl bg-gray-50 min-h-[120px]" placeholder="Your message..." required data-testid="contact-message-input" />
            </div>
            <Button type="submit" className="rounded-full bg-[#F5A623] hover:bg-[#e09515] text-white font-bold px-8 shadow-[0_4px_14px_rgb(245,166,35,0.4)] cta-button" data-testid="contact-submit-button">
              <Send className="w-4 h-4 mr-1" /> Send Message
            </Button>
          </form>
        </div>
        <div className="space-y-4">
          {[
            { icon: Mail, label: 'Email', value: 'hello@doggohub.com' },
            { icon: Phone, label: 'Phone', value: '(555) 123-4567' },
            { icon: MapPin, label: 'Address', value: 'San Francisco, CA' },
          ].map((item, i) => (
            <div key={i} className="bg-white rounded-2xl p-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <item.icon className="w-5 h-5 text-[#4A90E2] mb-2" />
              <p className="text-xs text-[#5C636A]">{item.label}</p>
              <p className="font-semibold text-[#1A1D20] text-sm">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
